import { createReducer, updateObject } from "../../utils/reduxHelper";
import constants from "./constants";

const initialState = {
  getUsersLoading: false,
  getUsersSuccess: false,
  getUsersError: null,
  allUsers: [],

  setManagerRoleLoading: false,
  setManagerRoleSuccess: false,
  setManagerRoleError: null,
  setManagerData: null,
  setManagerRoleFor: [],
};

/*
 * Get Users 
 */
const getUsersBegin = state => updateObject(state, { getUsersLoading: true });
const getUsersSuccess = (state, action) =>
  updateObject(state, {
    getUsersLoading: false,
    getUsersError: null,
    getUsersSuccess: true,
    allUsers: action.payload.data,
  });
const getUsersFailure = (state, action) =>
  updateObject(state, {
    getUsersLoading: false,
    getUsersError: action.payload,
  });

/**
 * Set Manager Role
 */

const setManagerRoleBegin = (state, action) =>
  updateObject(state, {
    setManagerRoleLoading: true,
    setManagerRoleFor: [...state.setManagerRoleFor, action.payload],
  });
const setManagerRoleSuccess = (state, action) => {
  let changedUserIndex = state.allUsers.findIndex(
    user => user.id == action.payload.data.id
  );
  let changedUsers = state.allUsers.slice();
  let changedUser = {
    ...changedUsers[changedUserIndex],
  };
  changedUser.is_manager = action.payload.data.is_manager;
  changedUsers[changedUserIndex] = changedUser;
  return updateObject(state, {
    setManagerRoleLoading: false,
    setManagerRoleError: null,
    setManagerRoleSuccess: true,
    setManagerData: action.payload.data,
    setManagerRoleFor: state.setManagerRoleFor.filter(
      item => item !== action.payload.data.id
    ),
    allUsers: changedUsers,
  });
};
const setManagerRoleFailure = (state, action) =>
  updateObject(state, {
    setManagerRoleLoading: false,
    setManagerRoleError: action.payload,
    setManagerRoleFor: state.setManagerRoleFor.filter(
      item => item !== action.payload.data.id
    ),
  });

/**
 * Handlers
 */

const handlers = {};
handlers[constants.GET_ALL_USERS_BEGIN] = getUsersBegin;
handlers[constants.GET_ALL_USERS_SUCCESS] = getUsersSuccess;
handlers[constants.GET_ALL_USERS_FAILURE] = getUsersFailure;
handlers[constants.SET_MANAGER_STATUS_BEGIN] = setManagerRoleBegin;
handlers[constants.SET_MANAGER_STATUS_SUCCESS] = setManagerRoleSuccess;
handlers[constants.SET_MANAGER_STATUS_FAILURE] = setManagerRoleFailure;

const managerReducer = createReducer(initialState, handlers);

export default managerReducer;



// WEBPACK FOOTER //
// ./src/modules/manager/reducer.js